


















import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    ADD_ANIMATION
} from "../store/mutations.names";
import {
    TimelineMax,
    Power1,
    Power2,
    Power4,
    Power3
} from "gsap";
import {
    HOST
} from "../global";
import 'video.js/dist/video-js.css';

//import { videoPlayer } from 'vue-video-player';
@Component({
    name: "FullImg",
    components: {
        // videoPlayer
    }
})
export default class FullImg extends Vue {
    @Prop() public compData!: string | null;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;
    public HOST: string = HOST;
    showmodel: boolean = false;

    //  playerOptions: any = {
    //         height: '100',
    //         width: '100',
    //         autoplay: false,
    //         muted: false,
    //         language: 'en',
    //         playbackRates: [0.7, 1.0, 1.5, 2.0],
    //         sources: [{
    //           type: "video/mp4",
    //           // mp4
    //           src: "http://vjs.zencdn.net/v/oceans.mp4",

    //         }],
    //         poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",

    // }

    //  player() {
    //     return (this as any).$refs.videoPlayer.player
    //   }
    //  onPlayerPlay(player: any) {
    //    console.log('player play!', player)
    //   }
    //   onPlayerPause(player: any) {
    //     console.log('player pause!', player)
    //   }
    //   onPlayerEnded(player: any) {
    //      console.log('player ended!', player)
    //   }
    //   onPlayerLoadeddata(player: any) {
    //      console.log('player Loadeddata!', player)
    //   }
    //   onPlayerWaiting(player: any) {
    //      console.log('player Waiting!', player)
    //   }
    //   onPlayerPlaying(player: any) {
    //     console.log('player Playing!', player)
    //   }
    //   onPlayerTimeupdate(player: any) {
    //      console.log('player Timeupdate!', player.currentTime())
    //   }
    //   onPlayerCanplay(player: any) {
    //     console.log('player Canplay!', player)
    //   }
    //   onPlayerCanplaythrough(player: any) {
    //      console.log('player Canplaythrough!', player)
    //   }
    //   // or listen state event
    //   playerStateChanged(playerCurrentState: any) {
    //      console.log('player current update state', playerCurrentState)
    //   }

    //     playerReadied(player: any) {
    //     // seek to 10s
    //     console.log('example player 1 readied', player)
    //     player.currentTime(10)
    //     // console.log('example 01: the player is readied', player)
    //   }

    //  videomodal() {
    //     var videomodal = new TimelineMax({});
    //     videomodal

    //       .staggerFrom(
    //         ".play-btn",
    //         0.5,
    //         {
    //           yPercent: 20,
    //           autoAlpha: 0,
    //           opacity: 0,
    //           ease: Power4.easeOut,
    //           clearProps: "all"
    //         },
    //         0.05
    //       );
    //   }
    public abimgnim(): void {
        var abimgnim = new TimelineMax({});
        abimgnim
            .staggerFrom(
                ".abimg-ban",
                0.7, {
                    scale: .95,
                    autoAlpha: 0,
                    opacity: 0,
                    ease: Power3.easeOut,
                    clearProps: "all"
                },
                0.05
            )
            .staggerFrom(
                ".ab-text h1",
                0.7, {
                    yPercent: 20,
                    autoAlpha: 0,
                    opacity: 0,
                    ease: Power3.easeOut,
                    clearProps: "all"
                },
                0.05
            );

        // if (this.last) {
        //     this.$emit("loaded");
        // }
    }
}
